/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

export const BROWSE_MARKETPLACE_ONCLICK_EVENT = 'browseMarketplaceOnClickEvent';
export const BROWSE_MARKETPLACE_ONDESTROY_EVENT = 'browseMarketplaceOnDestroyEvent';

class BrowseMarketplaceButtonEventManager {
  constructor() {
    this.events = {};
  }

  subscribe(eventName, callback) {
    if (!this.events[eventName]) {
      this.events[eventName] = [];
    }

    this.events[eventName].push(callback);
  }

  unsubscribe(eventName, callback) {
    if (!this.events[eventName]) {
      return;
    }

    this.events[eventName] = this.events[eventName].filter((cb) => cb !== callback);
  }

  emit(eventName, ...args) {
    if (!this.events[eventName]) {
      return;
    }

    this.events[eventName].forEach((cb) => cb(...args));
  }
}

export default new BrowseMarketplaceButtonEventManager();
